import { ColoursObj, Typography } from "@eventr/common-storybook";
import { Stack } from "@mui/material";
import { getFileName } from "feat/media/media.slice";
import { Utils } from "utils";
import { useObjectContext } from "../providers/objectProvider";
interface FileListProps {
  files: string[];
}
export const FileList = ({ files }: FileListProps) => {
  const { past } = useObjectContext();

  return (
    <>
      {files.length > 0 && (
        <Stack spacing="12px">
          {" "}
          {/* I have removed the padding  24px from  here as its used in multiple locations.*/}
          {files &&
            typeof files !== "undefined" &&
            files.map((f, i) => {
              return (
                <Stack key={i} spacing="12px" direction="row" sx={{
                  flexWrap: "wrap"
                }}>
                  <Typography
                    id={i + "Uploadedfile"}
                    onClick={() => {
                      Utils.downloadAndOpenFile(f);
                    }}
                    style={{ lineBreak: "anywhere" }}
                    color={past ? ColoursObj.shades.shade2 : undefined}
                    variant="bodyRegularUnderlined"
                  >
                    {getFileName(f)}
                  </Typography>
                </Stack>
              );
            })}
        </Stack>
      )}
    </>
  );
};
